// extracted by mini-css-extract-plugin
module.exports = {"date":"styles_date__9eSO_","label":"styles_label__mrXUn","value":"styles_value__gG3Do","skeleton-animation":"styles_skeleton-animation__Ri1qr"};